import store from '../store';

export default function getUserId() {
	return store('id');
}
